import { Decoration_Type } from 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const convertDocumentStyleDecorationTypes = (decorations) => {
  let draftBlockStyles = {};
  decorations.forEach((decoration) => {
    decoration && (draftBlockStyles = __spreadValues(__spreadValues({}, draftBlockStyles), ricosDecorationToCss[decoration.type](decoration)));
  });
  return draftBlockStyles;
};
const ricosDecorationToCss = {
  [Decoration_Type.BOLD]: ({ fontWeightValue }) => {
    return fontWeightValue ? { "font-weight": fontWeightValue >= 700 ? "bold" : "normal" } : {};
  },
  [Decoration_Type.ITALIC]: ({ italicData }) => {
    return typeof italicData !== "undefined" ? { "font-style": italicData ? "italic" : "normal" } : {};
  },
  [Decoration_Type.UNDERLINE]: ({ underlineData }) => {
    return typeof underlineData !== "undefined" ? {
      "text-decoration": underlineData ? "underline" : "none"
    } : {};
  },
  [Decoration_Type.FONT_SIZE]: ({ fontSizeData }) => {
    return fontSizeData ? { "font-size": fontSizeData.value + (fontSizeData.unit.toLowerCase() || "px") } : {};
  },
  [Decoration_Type.COLOR]: ({ colorData }) => {
    const { foreground, background } = colorData;
    const colors = {};
    foreground && (colors["color"] = foreground);
    background && (colors["background-color"] = background);
    return colors;
  }
};
const convertNodeStyleToCss = (nodeStyle) => {
  const css = {};
  nodeStyle.paddingTop && (css["padding-top"] = nodeStyle.paddingTop);
  nodeStyle.paddingBottom && (css["padding-bottom"] = nodeStyle.paddingBottom);
  nodeStyle.lineHeight && (css["line-height"] = nodeStyle.lineHeight);
  return css;
};
const parseDocStyle = (documentStyle) => {
  const draftDocStyle = {};
  Object.entries(documentStyle).forEach(([header, values]) => {
    if (values) {
      const { decorations = [], nodeStyle, lineHeight } = values;
      draftDocStyle[header] = __spreadValues(__spreadValues({}, convertDocumentStyleDecorationTypes(decorations)), convertNodeStyleToCss(__spreadProps(__spreadValues({}, nodeStyle), { lineHeight })));
    }
  });
  return draftDocStyle;
};

export { parseDocStyle };
